<template>
  <svg v-if="!error" :width="width" :height="height" fill="#fff">
    <rect fill="#fff" :width="width" :height="height" :rx="roundedBorder" fill-opacity="1" />
    <rect x="0" y="4" :fill="color" :width="total" :height="height - 8"  :rx="roundedBorder" />
  </svg>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      height: 15,
      width: 300,
      color: '#00B0B9',
      percent: 0,
      intervalId: null
    }
  },
  computed: {
    roundedBorder () {
      return (this.height / 2).toFixed(2)
    },
    total () {
      return (this.percent > 50 || this.percent === 0) ? (this.percent / 100) * this.width : ((this.percent / 100) * this.width) + this.width * 0.05
    }
  },
  methods: {
    increment () {
      if (this.percent < 100) {
        this.percent = this.percent + 0.5
        window.requestAnimationFrame(this.increment)
      }
    }
  },
  mounted () {
    this.increment()
  }
}
</script>
